const entityKey = {
    ggId: 'ggId',
    userId: 'userId',
    deviceId: 'deviceId',
};

export default entityKey;
